module.exports = __webpack_public_path__ + "static/media/family.7374735c.svg";